import { loginRequest, graphConfig } from "../authConfig";
import { msalInstance } from "../index";

export async function callMsGraph() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

export async function getAccessToken(scopes: string[]): Promise<string> {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }
    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        scopes,
        account
    });
    return response.accessToken;
}

export async function msGraphApiCall(url: string, method: string = "GET", scopes: string[], body?: any): Promise<any> {
    const accessToken = await getAccessToken(scopes);
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${accessToken}`);
    if (body) {
        headers.append("Content-Type", "application/json");
    }
    const options: RequestInit = {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined
    };
    const res = await fetch(url, options);
    if (!res.ok) throw new Error(`Graph API error: ${res.status}`);
    return res.json();
}
